module.exports = __webpack_public_path__ + "static/media/logo.ef3a8c6f.png";